import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from 'src/components/ui/dialog';
import { Button } from 'src/components/ui/button/button';
import { Loader2, Sparkles } from 'lucide-react';
import { VideoAnalysisService, VideoAnalysisTriggerRequest } from 'src/services/video-analysis/video-analysis.service';

interface ContentGenerationProgressModalProps {
  isOpen: boolean;
  onClose: () => void;
  contentType: VideoAnalysisTriggerRequest['request_type'] | null;
  onCancel?: () => void;
}

export const ContentGenerationProgressModal: React.FC<ContentGenerationProgressModalProps> = ({
  isOpen,
  onClose,
  contentType,
  onCancel,
}) => {
  const handleClose = () => {
    onCancel?.();
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && handleClose()}>
      <DialogContent className="tw-flex tw-max-h-[90vh] tw-max-w-md tw-flex-col">
        <DialogHeader className="tw-flex-shrink-0">
          <DialogTitle className="tw-flex tw-items-center tw-justify-between tw-pr-8">
            <div className="tw-flex tw-items-center tw-gap-2">
              <Sparkles className="tw-h-5 tw-w-5 tw-text-purple-600" />
              <span>beN Generation</span>
            </div>
          </DialogTitle>
        </DialogHeader>

        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-space-y-4 tw-py-8">
          <Loader2 className="tw-h-8 tw-w-8 tw-animate-spin tw-text-purple-600" />
          <div className="tw-text-center">
            <p className="tw-font-medium">
              Generating {contentType ? VideoAnalysisService.getRequestTypeLabel(contentType) : 'Content'}...
            </p>
            <p className="tw-mt-1 tw-text-sm tw-text-gray-500">
              beN is analyzing your video and creating content. This may take up to 30 seconds.
            </p>
          </div>
        </div>

        {/* Cancel button */}
        <div className="tw-flex tw-justify-end tw-gap-2">
          <Button
            variant="outline"
            onClick={handleClose}
            size="sm"
          >
            Cancel
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
